import React, { useState } from "react";
import { FaBars, FaUser } from "react-icons/fa";
import { MdOutlineLogout, MdPassword } from "react-icons/md";
import { Link } from "react-router-dom";
import ChangePassword from "../Modals/ChangePassword";

const Header = ({ setExpanded, isExpanded, setExpandedMob, isExpandedMob }) => {
  const [openBox, setOpenBox] = useState(false);
  const [openAddModal, setOpenAddModal] = useState();

  const userModal = () => {
    setOpenBox(!openBox);
  };
  const handleLogout = () => {
    localStorage.removeItem("access_token");
  };

  return (
    <>
      <div className="header header-one">
        <span id="toggle_btn" onClick={() => setExpanded(!isExpanded)}>
          <FaBars />
        </span>

        <div className="block-area" />
        <div className="block-area" />

        <span
          className="mobile_btn"
          id="mobile_btn"
          onClick={() => setExpandedMob(!isExpandedMob)}
        >
          <FaBars />
        </span>

        <h3 className="logo-typo">Super Counsellor</h3>
        <ul className="nav nav-tabs user-menu">
          <li className="nav-item dropdown has-arrow main-drop">
            <span className="dropdown-toggle nav-link" onClick={userModal}>
              <span className="user-img">
                <FaUser className="me-2" />
              </span>
              <span>Admin</span>
            </span>

            {openBox && (
              <div className="dropdown-menu">
                <Link
                  className="dropdown-item"
                  to="/login"
                  onClick={handleLogout}
                >
                  <MdOutlineLogout className="me-1" />
                  Logout
                </Link>

                <Link
                  className="dropdown-item"
                  onClick={() =>
                    setOpenAddModal({
                      action: "Add",
                      data: "",
                    })
                  }
                >
                  <MdPassword className="me-1" />
                  Change Password
                </Link>
              </div>
            )}
          </li>
        </ul>
      </div>

      {openAddModal && (
        <ChangePassword data={openAddModal} onClose={() => setOpenAddModal()} />
      )}
    </>
  );
};

export default Header;
